<div class="product_data flex" [formGroup]="produtoForm">
  <div class="rotate_text flex"><div class="rotate_item">{{ 'Produtos' | translate}}</div></div>

  <div class="product_data__items">
  
    <div class="flex">
      <div class="product_data__item_produto">
        {{ 'Produto' | translate}}
      </div>
      <div class="product_data__item_posologia posologia_title_fix">
        {{ 'Posologia' | translate}}
      </div>
    </div>

    <div class="product_data__items_scroll">

      <div class="flex gap-1">
        <button type="button" class="addRemoveButton" (click)="addProdutoFirst()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
        </button>
      </div>
      <ng-container *ngFor="let produto of produtoForm.controls; let i = index" [formGroupName]="i">
        <div>
          <div class="flex">
              <div class="product_data__item_produto">
                <ng-container *ngIf="isSmartCase; else normalInputProdutoNome">
                  <input type="text" formControlName="nome" (keypress)="validarEntrada.emit($event)" (keyup)="verificarAtalho($event, i)" [ngClass]="{'uppercase': !isProdutoFieldDirty(i, 'nome'), 'lowercase': isProdutoFieldDirty(i, 'nome')}" #produtoInput appClearOnAltD appSmartCase />
                </ng-container>
                <ng-template #normalInputProdutoNome>
                  <input type="text" formControlName="nome" (keypress)="validarEntrada.emit($event)" (keyup)="verificarAtalho($event, i)" #produtoInput appClearOnAltD />
                  <!-- [matAutocomplete]="autoProduto" -->
                </ng-template>
          
                <mat-autocomplete #autoProduto="matAutocomplete">
                  <mat-option *ngFor="let produto of produtoFiltrado | slice:0:5" [value]="produto">
                    {{ produto | lowercaseCustom }}
                  </mat-option>
                  <mat-option *ngIf="produtoFiltrado.length === 0" disabled>
                    {{ 'Sem sugestões' | translate}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="product_data__item_posologia">
          
                <ng-container *ngIf="isSmartCase; else normalInputProdutoPosologia">
                  <input type="text" formControlName="posologia" (keypress)="validarEntrada.emit($event)" [ngClass]="{'uppercase': !isProdutoFieldDirty(i, 'posologia'), 'lowercase': isProdutoFieldDirty(i, 'posologia')}" appClearOnAltD appSmartCase />
                  <!-- [matAutocomplete]="autoPosologia" -->
                </ng-container>
                <ng-template #normalInputProdutoPosologia>
                  <input type="text" formControlName="posologia" (keypress)="validarEntrada.emit($event)" appClearOnAltD appLowercaseOnChange />
                </ng-template>

                <mat-autocomplete #autoPosologia="matAutocomplete">
                  <mat-option *ngFor="let posologia of posologiaFiltrado | slice:0:5" [value]="posologia">
                    {{ posologia | lowercaseCustom }}
                  </mat-option>
                  <mat-option *ngIf="posologiaFiltrado.length === 0" disabled>
                    {{ 'Sem sugestões' | translate}}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <button type="button" class="addRemoveButton" (click)="removeProduto(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line></svg>
              </button>
              <button type="button" class="addRemoveButton" (click)="addProdutoNext(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#aa0012" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
              </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  
</div>